import * as React from "react";
import { connect } from "react-redux";
import { mapDispatchToProps } from "../../redux/actions";
import "../../css/FactoryRequestLockedModal.scss";
// expected props
interface IProps {
  updateRedux: any;
  reduxModals: any;
}
// local state
interface IState {}

class UnitInProEditMode extends React.Component<IProps, IState> {
  public state: IState = { };

  public render() {

    return (
        <div className="factory-request-overlay">
          <div className="factory-request-modal">
    
            {/* Close Button */}
            <button className="factory-request-close"
              onClick={() => this.userResponse("cancel")}
              type="button"
            >
              &times;
            </button>
    
            {/* Header */}
            <div className="factory-request-header">
              <div className="factory-request-lock"></div>
              <h2>Please Note:</h2>
            </div>
    
            {/* Content */}
            <div className="factory-request-content">
              <p>
                This unit is locked because a Factory Request has been submitted to
                Innovent Engineering.
              </p>
              <p>
                As a result, the design can no longer be edited in SpecMate.
              </p>
              <p>
                Factory Requests are still available for any changes to the unit
                design, requesting a submittal or to release the project.
              </p>
            </div>
    
            <div className="factory-request-divider" />
    
            {/* Footer */}
            <div className="factory-request-footer">
              <button className="factory-request-button"
                onClick={() => this.userResponse("ok")}
                type="button"
              >
                <span className="factory-request-button-icon"></span>
                Go to Factory Request
              </button>
            </div>
          </div>
        </div>
      );
  }
  private userResponse(response: string) {
    let unitInProEditModeResponse = {
      response: response,
      clickedUnit:this.props.reduxModals.modalData.clickedUnit
    };
    this.props.updateRedux("UPDATE_MODALS", { showModal: false, userResponse: unitInProEditModeResponse });
  }
}

//------------------ Redux ----------------------------
function mapStateToProps(state: any) {
  return {
    reduxModals: state.reduxModals
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(UnitInProEditMode);
